
export default {
	banner: state => state.banner,
	modal: state => state.modal,
	modalOptions: state => state.modalOptions
}
